import { DeleteOutlined } from '@ant-design/icons';
import { Button } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { TableActionsTypes } from 'constants/TableActionsTypes';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import CamelCaseToWords from 'utils/helpers/CamelCaseToWords';

export const deleteAction = ({
    service,
    serviceByCondition,
    idByCondition,
    condition,
}) => {
    return props => {
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id, row } = params;
        const entity = service.getModel();
        const deleteService =
            !!condition && params?.row?.rowType === condition
                ? serviceByCondition
                : service;
        const deleteId =
            !!condition && params?.row?.rowType === condition
                ? params.row[idByCondition]
                : id;

        const title = CamelCaseToWords(entity.ModelFeatureAttribute.CLASS_NAME);

        let confirmationText = <>Are you sure you want to delete {title}?</>;

        const isHideMenuItem =
            !entity.ModelFeatureAttribute[TableActionsTypes.Deactivate] ||
            (entity.ModelFeatureAttribute[TableActionsTypes.Deactivate] &&
                row?.inactive);
        const value = 'delete';
        const label = 'Delete';

        const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);

        const handleOpenConfirmationModal = () => {
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };
        const handleDelete = async () => {
            try {
                await deleteService.delete(deleteId);
                enqueueSnackbar(title + ' was deleted', {
                    variant: 'success',
                });
                onClick(value);
                handleCloseConfirmationModal();
            } catch (err) {
                const { errors, message } = err?.response?.data;
                if (message) {
                    enqueueSnackbar(message, { variant: 'error' });
                } else if (!errors || errors?.length === 0) {
                    enqueueSnackbar('Unable to delete ' + title, {
                        variant: 'error',
                    });
                } else {
                    errors.forEach(error => {
                        if (error?.type === 'validation') {
                            enqueueSnackbar(`${error?.errorMessage}`, {
                                variant: 'error',
                            });
                        }
                    });
                }
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={handleCloseConfirmationModal}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDelete}
                                color="primary"
                                variant="contained"
                            >
                                Delete
                            </Button>
                        </>
                    )}
                >
                    {confirmationText}
                </ConfirmationModal>
                {isHideMenuItem && (
                    <MenuItem
                        key={value}
                        value={value}
                        label={label}
                        icon={<DeleteOutlined />}
                        onClick={handleOpenConfirmationModal}
                        {...restProps}
                    >
                        {label}
                    </MenuItem>
                )}
            </>
        );
    };
};
